/* global app */
import React, { useMemo, useCallback } from 'react'
import { connect } from 'react-redux'
import { loadCustomerData } from 'customerActions.js'
import { SBPayments } from '@sb-software/sb-payments-etoto'
import * as styled from 'StyledAccountWithdraw'

const { useSession, Withdraw } = SBPayments

const AccountWithdraw = ({ isLogged, balance, currencyCode, loadCustomerData, status }) => {
  const session = useSession()

  // Watch for '2' which stands for MOBILE
  const lang = useMemo(() => `lang_${app.config.lang}_${app.config.mainCountryCode}_1_2`.toLowerCase(), [app.config.lang, app.config.mainCountryCode])
  const shouldWithdrawButtonBeDisabled = status == 'TEMPORARY_ACCOUNT'
  const onSuccess = useCallback(() => loadCustomerData({
    keepSessionAlice: false,
    updateBalance: true
  }), [loadCustomerData])

  return (
    <styled.Wrapper>
      {isLogged && (
        <Withdraw
          lang={lang}
          session={session}
          balance={balance}
          currencyCode={currencyCode}
          onSuccess={onSuccess}
          shouldWithdrawButtonBeDisabled={shouldWithdrawButtonBeDisabled}
        />
      )}
    </styled.Wrapper>
  )
}

const mapStateToProps = ({ Auth: { isLogged, user: { balance, currencyCode, status } } }) => {
  return {
    isLogged,
    balance,
    currencyCode,
    status,
  }
}

export default connect(mapStateToProps, { loadCustomerData })(AccountWithdraw)